<template lang="pug">
  span
    a(v-if="isExt(link.url)", :href="link.url", :target="link.target", :rel="link.target === '_blank' && 'noopener'", :class="linkClss")
      slot
    router-link(v-else, :to="resolve(link.url)", :class="linkClss")
      slot
</template>

<script>
import { linkResolver, isExtLink } from '@/utils'
export default {
  name: 'WPLink',
  props: {
    link: { type: Object, default: () => { return { title: 'Missing Link', url: '/' } } },
    // text: { type: String, default: null },
    linkClss: { type: String, default: '' }
  },
  data () {
    return {
      resolve: linkResolver,
      isExt: isExtLink
    }
  }
}
</script>

<style>
</style>
